import { html, defineElement } from '@webtides/element-js';

import frameStyles from './_frame-selector.css';

import BaseFrameSelector from '@zeg/base-light-module/frontend/components/structures/frame-selector/frame-selector.class';

class FrameSelector extends BaseFrameSelector {
    afterUpdate() {
        // Override the afterUpdate hook so that the hover indicator doesn't get initialized.
    }

    styles() {
        return [frameStyles];
    }
}

defineElement('frame-selector', FrameSelector);
